<script setup lang="ts">
defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'blur', event: FocusEvent): void
  (e: 'focus', event: FocusEvent): void
}>()

withDefaults(
  defineProps<{
    modelValue?: string
    label?: string
    ariaLabel?: string
    type?: string
    placeholder?: string
    name: string
    disabled?: boolean
    required?: boolean
    error?: string
  }>(),
  {
    type: 'text',
  }
)
</script>

<template>
  <label class="block">
    <span v-if="label" class="mb-1 text-sm font-medium text-gray-600">
      {{ label }} {{ !required ? `(${$t('forms.optional')})` : '' }}
    </span>

    <input
      :name="name"
      :value="modelValue"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
      @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
      :type="type"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      :aria-label="ariaLabel"
      class="block h-10 w-full rounded-md border-gray-300 shadow-sm transition hover:border-gray-400 focus:ring focus:ring-main-500 focus:ring-opacity-50"
    />

    <ErrorMessage v-if="error" :error="error" />
  </label>
</template>
